import { FC, useEffect, useState } from "react";
import { UserActionPlan } from "@/data/interfaces/UserActionPlan";
import userActionPlanService from "@/services/userActionPlanService";
import { GoalItem } from "./GoalItem";
import { ErrorMessage } from "@/components/UI";
import { Dumbbell, Zap, Salad } from "lucide-react";

const GOAL_ICONS = [
  <Dumbbell className="h-5 w-5 text-[#6935B1]" />,
  <Zap className="h-5 w-5 text-[#F04438]" />,
  <Salad className="h-5 w-5 text-[#F04438]" />,
];

const GOAL_COLORS = [
  "bg-gradient-to-r from-[#6935B1] to-[#967CFD]",
  "bg-gradient-to-r from-[#F04438] to-[#FFEDB8]",
  "bg-gradient-to-r from-[#F04438] to-[#FFEDB8]",
];

export const GoalsPanel: FC = () => {
  const [goals, setGoals] = useState<UserActionPlan[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    loadGoals();
  }, []);

  const loadGoals = async () => {
    try {
      setIsLoading(true);
      setErrorMessage(undefined);
      const data = await userActionPlanService.getMyActionPlans();
      setGoals(data.slice(0, 3));
    } catch (error) {
      console.error(error);
      setErrorMessage(`Failed to load goals: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="w-[413px] rounded-2xl bg-white p-6 shadow-sm">
        <h3 className="mb-6 text-lg font-semibold text-gray-900">
          Your Goals for Q1
        </h3>
        <div className="text-center text-gray-500">Loading goals...</div>
      </div>
    );
  }

  return (
    <div
      className="w-[413px] rounded-2xl bg-white p-6 shadow-sm"
      style={{ minHeight: "279px" }}
    >
      <h3 className="mb-6 text-lg font-medium text-gray-900">
        Your Goals for Q1
      </h3>

      <ErrorMessage error={errorMessage} />

      {goals.length > 0 ? (
        <div className="flex flex-col gap-6">
          {goals.map((goal, index) => (
            <GoalItem
              key={goal.id}
              title={goal.insight_type?.name ?? "Goal"}
              subtitle={goal.rules}
              progress={goal.percent}
              imageUrl={goal.insight_type?.image ?? undefined}
              icon={GOAL_ICONS[index % GOAL_ICONS.length]}
              colorClass={GOAL_COLORS[index % GOAL_COLORS.length]}
            />
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-500">
          No goals set for Q1 yet.
        </div>
      )}
    </div>
  );
};
